module.exports = __webpack_public_path__ + "img/ks-fully-funded.dd29766d.svg";